import { createContext, useContext, useMemo, useState } from 'react';

const HomeHeroContext = createContext(null);

export function HomeHeroProvider({ children }) {
  const [heroVisible, setHeroVisible] = useState(true);
  const value = useMemo(() => ({ heroVisible, setHeroVisible }), [heroVisible]);
  return <HomeHeroContext.Provider value={value}>{children}</HomeHeroContext.Provider>;
}

export function useHomeHero() {
  const ctx = useContext(HomeHeroContext);
  if (!ctx) {
    throw new Error('useHomeHero must be used within HomeHeroProvider');
  }
  return ctx;
}
